import { IAddUser } from '../../models/forms/IAddUpdateUser';
import { IChangePassword } from '../../models/forms/IChangePassword';

const initialState: IAddUser = {
  UserType: -1,
  Password: '',
  Email: '',
  UserName: '',
  AccountStatus: 1,
  TenantId: -1,
  Comment: '',
  ConfirmPassword: '',
  UserId: '',
  IsReserved: false,
  ProcessId: '',
};

export const ChangePasswordInitalState: IChangePassword = {
  NewPassword: '',
  ConfirmPassword: '',
};

export default initialState;
